import React from 'react';

import { AtlassianLogo } from '@atlaskit/logo/atlassian/logo';

const AtlassianLogoDefault = (): React.JSX.Element => {
	return <AtlassianLogo />;
};

export default AtlassianLogoDefault;
